module.exports = __webpack_public_path__ + "img/202509-2_05.fe540522.jpg";